import { Box } from '@mui/material';
import React from 'react';

interface Props {
    children?: any
}

const TeaserBanner : React.FC<Props> = ({children}) => {
    return <Box sx={{
        "& a": {
            color: 'primary.main' || '#0069b4',
            textDecoration: 'underline',
            transition: '0.1s ease-in',
        },
        "& a:hover": {
            opacity: 0.8,
            transition: "0.1s ease-in",
        },
        padding: '2rem',
        marginBottom: '1rem',
        marginTop: '1rem',
        borderRadius: '0 1rem 1rem 1rem',
        background: '#ffffff',
        backgroundColor: 'info.light' || '#ffffff',
    }}>{children}</Box>
}

export default TeaserBanner;